import { render, staticRenderFns } from "./observation.vue?vue&type=template&id=19b6a3d0&scoped=true&"
import script from "./observation.vue?vue&type=script&lang=js&"
export * from "./observation.vue?vue&type=script&lang=js&"
import style0 from "./observation.vue?vue&type=style&index=0&id=19b6a3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6a3d0",
  null
  
)

export default component.exports